import React, { Component } from 'react'
import Card from '../Card'
import './tableOfContents.scss'

class tableOfContents extends Component {
  constructor(props) {
    super(props)
    this.state = { dropDown: {} }
    this.setDropDown = this.setDropDown.bind(this)
  }

  setDropDown(id) {
    this.setState({ dropDown: { [id]: !this.state.dropDown[id] } })
  }

  render() {
    var parser = new DOMParser()
    var htmlDoc = parser.parseFromString(this.props.content, 'text/html')
    let list = []
    htmlDoc.querySelectorAll('h1, h2, h3, h4, h5, h6').forEach(x => {
      list.push({
        weight: x.tagName.replace('H', ''),
        innerText: x.innerText,
        id: x.id,
        children: [],
      })
    })

    list = list.reduce((acc, cur, i) => {
      if (acc.length > 0 && acc[acc.length - 1].weight < cur.weight) {
        acc[acc.length - 1].children.push(cur)
      } else {
        acc.push(cur)
      }
      return acc
    }, [])
    return (
      <Card>
        <div className="table-of-content-container">
          <div className="post-page-content">
            <div className="table-of-content-header">
              <h4>On this Page</h4>
              <button onClick={this.props.showSkipTo}>
                Close <i className="fa fa-close"></i>
              </button>
            </div>
            <div className="table-of-content-list">
              {list.map(item => (
                <div key={item.id}>
                  <div className="content-list-item-container">
                    {item.children.length ? (
                      <i
                        onClick={() => this.setDropDown(item.id)}
                        className={
                          this.state.dropDown[item.id]
                            ? 'fa fa-caret-down'
                            : 'fa fa-caret-right'
                        }
                      ></i>
                    ) : null}
                    <a className="content-list-item" href={'#' + item.id}>
                      {item.innerText}
                    </a>
                  </div>
                  {this.state.dropDown[item.id] ? (
                    <div className="content-list-children">
                      {item.children.map(child => (
                        <a
                          className="content-list-item"
                          key={child.id}
                          href={'#' + child.id}
                        >
                          {child.innerText}
                        </a>
                      ))}
                    </div>
                  ) : null}
                </div>
              ))}
            </div>
          </div>
        </div>
      </Card>
    )
  }
}

export default tableOfContents
